import { MDText } from 'i18n-react';

import { Modal } from '@motorway/motorway-storybook-cra';

import cypressIds from 'Components/cypress_ids.json';
import { useVehicleFeatures } from 'Components/pages/VehicleDetailsRedesign/sections/VehicleFeaturesSection/useVehicleFeatures';
import ListTable from 'Components/shared/ProTable/ListTable/ListTable';
import { mapFieldsToListTableValues } from 'Components/shared/ProTable/ListTable/ListTable.helpers';
import type { VehicleFeatures } from 'Pages/vehicles/helpers/vehicle.schema';
import { applyCypressData } from 'Utilities/helpers';

import { FeaturesRetailValue } from '../FeaturesRetailValue/FeaturesRetailValue';
import vehicleFeaturesSectionTexts from '../VehicleFeaturesSection.texts';

import { getFeaturesTableFields, getFeaturesTableSource } from './FeaturesModal.helpers';

import styles from './FeaturesModal.module.scss';

const LocalT = new MDText(vehicleFeaturesSectionTexts.modal);

interface FeaturesModalProps {
	equipment: VehicleFeatures['equipment'];
	highValueCarFeatures: VehicleFeatures['highValueCarFeatures'];
	modalHandler: () => void;
}

export const FeaturesModal: React.FC<FeaturesModalProps> = ({ equipment, highValueCarFeatures, modalHandler }) => {
	const { features, featuresCount } = useVehicleFeatures({ equipment, highValueCarFeatures });

	return (
		<Modal dismissModal={modalHandler} size="small">
			<section {...applyCypressData(cypressIds.containers.featuresModal)}>
				<header className={styles.title}>{LocalT.translate('title')}</header>
				<div className={styles.retailValue}>
					<FeaturesRetailValue highValueCarFeatures={highValueCarFeatures} variant="message" />
				</div>
				<div className={styles.costBreakdown}>
					<p className={styles.costBreakdownTitle}>
						{LocalT.translate('costBreakdownTitle')}
						<span className={styles.costBreakdownTitleSuffix}>{featuresCount}</span>
					</p>
					<ListTable
						omitNils
						valueClassName={styles.costBreakdownTableValue}
						// @ts-ignore
						values={mapFieldsToListTableValues({
							fields: getFeaturesTableFields(features),
							source: getFeaturesTableSource(features),
						})}
					/>
				</div>
			</section>
		</Modal>
	);
};
